import { render, staticRenderFns } from "./SpFeeOwed.vue?vue&type=template&id=79f1da36"
import script from "./SpFeeOwed.vue?vue&type=script&lang=js"
export * from "./SpFeeOwed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports